import '../../workspace/css/workspace.scss'

export default function ReplayTaskDescription({ task }) {
  return (
    <div className="ws-content-section">
      <h3 className="ws-section-title">Task Description</h3>
      {/* A rendered (non-string) task, e.g. markdown, lays out its own line breaks. */}
      <div className="ws-description-box" style={task && typeof task !== 'string' ? { whiteSpace: 'normal' } : undefined}>
        {task || <span style={{ color: '#999', fontStyle: 'italic' }}>No task description available.</span>}
      </div>
    </div>
  )
}